import { useEffect, useState, useCallback } from 'react';

import ProcessoService from '@services/ProcessoService';

const useRegioes = (processo) => {
    const [ data, setData ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);

    const fetchData = useCallback(() => {
        setLoading(true);

        if (!processo)
            return;

        ProcessoService.listarRegioes(processo)
            .then(res => setData(res.data.map(regiao => ({ label : regiao, value : regiao }) )))
            .catch(err => setError(err))
            .finally(() => setLoading(false));
    }, [processo]);

    useEffect(() => fetchData(), [fetchData]);

    return { data, loading, error };
}

export default useRegioes;